import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ITheme } from '@uifabric/styling';
import { getCalendarThemedButtonStyle } from 'owa-component-styling-utils';
import { peoplePickerAddRequiredPeoplePlaceHolder } from 'owa-locstrings/lib/strings/peoplepickeraddrequiredpeopleplaceholder.locstring.json';
import {
    peoplePickerAddPeoplePlaceHolder,
    galRequiredAttendees,
} from './AttendeeRows.locstring.json';
import loc from 'owa-localize';
import getComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getComposeViewState';
import { getRequiredRecipientWellViewState } from 'owa-calendar-compose-form-store/lib/utils/getRecipientWellViewState';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { ControlIcons } from 'owa-control-icons';
import {
    enableOptionalAttendeesWell,
    enableFocusOptionalAttendeeWellOnMount,
    updateRequiredAttendees,
} from 'owa-calendar-compose-form-actions';
import OptionalButton from './OptionalButton';
import EditableAttendeeRow from './EditableAttendeeRow';
import { shouldShowOptionalAttendeeButton } from 'owa-calendar-compose-form-store/lib/selectors/attendeeRowUtils';
import RecipientType from 'owa-recipient-types/lib/types/RecipientType';

export interface RequiredAttendeeRowProps {
    colorScheme: ColorScheme;
    theme: ITheme;
    showAvailability?: boolean;
    iconContainerClassName?: string;
    className?: string;
}

const RequiredAttendeeRow: React.FunctionComponent<RequiredAttendeeRowProps> = props => {
    const { event } = getComposeStore();
    const { isDarkMode } = getComposeViewState();
    const { colorScheme, theme, showAvailability, iconContainerClassName, className } = props;

    const showOptionalButton = shouldShowOptionalAttendeeButton();

    const optionalButton = showOptionalButton ? (
        <OptionalButton
            buttonStyle={getCalendarThemedButtonStyle(colorScheme, isDarkMode)}
            onClick={onOptionalButtonClick}
        />
    ) : undefined;

    return (
        <EditableAttendeeRow
            colorScheme={colorScheme}
            theme={theme}
            getWellViewState={getRequiredRecipientWellViewState}
            onAttendeesChanged={updateRequiredAttendees}
            placeholder={
                showOptionalButton
                    ? loc(peoplePickerAddPeoplePlaceHolder)
                    : loc(peoplePickerAddRequiredPeoplePlaceHolder)
            }
            attendees={event.RequiredAttendees}
            iconName={ControlIcons.Contact}
            optionalButton={optionalButton}
            showAvailability={showAvailability}
            iconContainerClassName={iconContainerClassName}
            galAriaLabel={loc(galRequiredAttendees)}
            recipientType={RecipientType.RequiredAttendee}
            className={className}
        />
    );
};

export default observer(RequiredAttendeeRow);

function onOptionalButtonClick() {
    enableOptionalAttendeesWell();
    enableFocusOptionalAttendeeWellOnMount(true);
}
